import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PlusIcon from "@mui/icons-material/Add";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import TrashIcon from "@mui/icons-material/DeleteOutlined";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import moment from "moment";
import SelectWithSearch from "../../../components/selectWithSearch";
import CheckBox from "../../../components/checkbox";
import { StyledLabel } from "../../../components/styles";
import {
    ErrorHint,
    StylesButtonLink,
    HintMsg,
    HintSuccessMsg,
    ConfirmSpo,
    TrashIconStyle,
    DefaultHintMsg,
} from "./../styles";
import {
    SeparateLine,
    ButtonRow,
    Tags,
    PageTitle,
    ProjectInfo,
    WorkingConditionSteps,
    MileageUnit,
    MileageInput,
    DataView,
    TagsContainer,
    StyledAction,
    ActionsContainer,
    ObjectionContainer,
    ProjectFinancialLegalContainer,
    ConditionSteps,
    ProjectCondition,
} from "../../../styles/elements/main";

import {
    FormGroup,
    FormRow,
    FormStyle,
    Error,
    FormGroupTextEditor,
} from "../../../styles/forms/main";
import {
    getSuppliersList,
    getTrucksList,
    deleteSupplierPerCondition,
    getObjectionById,
    updateProjectInfo,
    uploadProjectInfoAttachments,
    deleteSingleAttachment,
    deleteAllAttachments,
    getConditionById,
    getDriversList,
    updateProfileSupplierForm,
    getStandardsAndProceduresList,
} from "../api";
import Input from "../../../components/input";
import {
    mapOptionsToUi,
    mapSupplierConditionToUi,
    mapTruckOptionsToUi,
    mapObjectionsToUi,
} from "../mapToUi";
import {
    mapSuppliersTrucksToData,
    mapUpdateSupplierProjectInfoToData,
    mapSupplierFormToData,
} from "../mapToData";
import Button from "../../../components/button";
import AccordionComponent from "../../../components/accordion";
import TabList from "../../../components/tabList";

import Action from "../../../components/dropdownAction";
import { setMessage } from "../../shared/notification/slice";
import ObjectionsView from "./objectionsView";
import { filterArrayWithSelectedObject } from "../../../utils/FilterArrayWithSelectedObjects";
import ProjectFinancialLegalForm from "./ProjectFinancialLegal";
import ModalComponent from "../../../components/modal";
import QADetails from "./QADetails";
import { convertFileToBase64 } from "../../../utils/getBase64";
import { showLoader } from "../../shared/FullPageLoader/slice";
import Spinner from "../../../components/Spinner";
import SupplierPricingDetails from "./SupplierPricingDetails";
import ClientPricingDetails from "./ClientPricingDetails";
import TextArea from "../../../components/textArea";
import trackAnalytics from "../../../trackAnalytics";
import { getUserRoles } from "../../auth/slice";
import { compareObjects } from "../../../hooks/compareObjects";
import {
    mapUpdateProjectInfoToMixPanel,
    mapSupplierWorkingConditionsDataToMixPanel,
} from "../mapDataToMixpanel";
import ExtraOperationalRequirements from "./ExtraOperationalRequirements";

export default function SupplierProfile({
    projectId,
    clientProject,
    organizationId,
    penaltiesAndDeductions,
    setPenaltiesAndDeductions,
    setAllIllaDeductions,
    setAllClientDeductions,
    allIllaDeductions,
    allClientDeductions,
}) {
    const [supplierWorkingConditionIsValid, setSupplierWorkingConditionIsValid] = useState(true);
    const [activeWorkingCondition, setActiveWorkingCondition] = useState(0);
    const [editableConditionId, setEditableConditionId] = useState(0);
    const [isEditable, setIsEditable] = useState(false);
    const [FilteredSuppliersList, setFilteredSuppliersList] = useState([]);
    const [supplierConditions, setSupplierConditions] = useState({
        fullFillmentDetails: {
            suppliers: [
                {
                    supplier: null,
                    numberOfTrucks: 0,
                    assignedTrucks: [],
                    kiloMeters: "",
                    workingHoursPerDay: "",
                    trucksList: [],
                    driversList: [],
                    selectedTrucks: {},
                    selectedDrivers: {},
                    filteredTrucksList: [],
                    filteredDriversList: [],
                },
            ],
        },
        pricingDetails: {},
        salesConditions: {},
        objectionsId: [],
    });
    const [initialSupplierConditions, setInitialSupplierConditions] = useState({});
    const [supplierConditionsUpdatedData, setSupplierConditionsUpdatedData] = useState({
        fullFillmentDetails: {
            suppliers: [],
        },
        pricingDetails: {},
    });
    const [clickOnSubmit, setClickOnSubmit] = useState(false);
    const [remainingTrucks, setRemainingTrucks] = useState(0);
    const [assignedTrucksNumber, setAssignedTrucksNumber] = useState(0);
    const [formIsValid, setFormIsValid] = useState(true);
    const [updatedSupplier, setUpdatedSupplier] = useState([]);
    const [conditionId, setConditionId] = useState("");
    const dispatch = useDispatch();
    const history = useHistory();
    const [supplierTrucksList, setSupplierTrucksList] = useState({ data: [], supplierId: "" });
    const [supplierDriversList, setSupplierDriversList] = useState({ data: [], supplierId: "" });
    const [objection, setObjection] = useState({});
    const [showEditableField, setShowEditableField] = useState(false);
    const [activeObjection, setActiveObjection] = useState("");
    const [SubmitObjectSuccess, setSubmitObjectSuccess] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState({});
    const [selectedTrucks, setSelectedTrucks] = useState({});
    const [selectedDrivers, setSelectedDrivers] = useState({});
    const [updateFilteredTrucks, setUpdateFilteredTrucks] = useState(false);
    const [isProjectInfoEditable, setIsProjectInfoEditable] = useState(false);
    const [showDiscardEditModal, setShowDiscardModal] = useState(false);
    // QA details sections
    const [qaDetails, setQaDetails] = useState({});
    const [standardsAndProceduresList, setStandardsAndProceduresList] = useState([]);
    // Project Financial section
    const [projectFinancialLegal, setProjectFinancialLegal] = useState({});
    const [supplierAttachments, setSupplierAttachments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const getCurrentUserRoles = useSelector(getUserRoles());

    const fetchStandardsAndProcedures = async () => {
        const data = await getStandardsAndProceduresList();
        setStandardsAndProceduresList(
            mapOptionsToUi(
                _.values(data?.entities["standardsAndOperationalProcedures"]),
                "id",
                "description"
            )
        );
    };

    useEffect(() => {
        setQaDetails(clientProject?.qaDetails);
        setProjectFinancialLegal(clientProject?.projectFinancialLegal);
        fetchStandardsAndProcedures();
        setPenaltiesAndDeductions(clientProject?.deductionsValues);
    }, [clientProject]);

    useEffect(() => {
        if (
            !clientProject?.projectFinancialLegal?.supplyPaymentCycleDays ||
            !clientProject?.projectFinancialLegal?.supplyReviewCycle
        ) {
            setIsProjectInfoEditable(true);
        }
    }, [clientProject]);

    useEffect(() => {
        SubmitObjectSuccess && getObjection(activeObjection);
        setSubmitObjectSuccess(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SubmitObjectSuccess]);

    useEffect(() => {
        if (clientProject?.salesConditionsId?.length > 0) {
            fetchSupplierProfileCondition(clientProject?.salesConditionsId[0]);
            setConditionId(clientProject?.salesConditionsId[0]);
            setEditableConditionId(clientProject?.salesConditionsId[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientProject]);

    useEffect(() => {
        isEditable && fetchSupplierTrucks();
        isEditable && fetchSupplierDrivers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditable]);

    useEffect(() => {
        setClickOnSubmit(false);
        setIsEditable(false);
        setSupplierConditions({
            ...supplierConditions,
            fullFillmentDetails: {
                ...supplierConditions?.fullFillmentDetails,
                suppliers: [
                    {
                        supplier: null,
                        numberOfTrucks: 0,
                        assignedTrucks: [],
                        kiloMeters: "",
                        workingHoursPerDay: "",
                        trucksList: [],
                        driversList: [],
                        selectedTrucks: {},
                        selectedDrivers: {},
                        filteredTrucksList: [],
                        filteredDriversList: [],
                    },
                ],
                numberOfHelpers: 0,
                deliveryDelegate: 0,
            },
        });
        fetchSuppliersList();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (clickOnSubmit) {
            if (formIsValid) {
                handleSupplierSubmitForm();
            } else {
                setSupplierWorkingConditionIsValid(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formIsValid, clickOnSubmit]);

    useEffect(() => {
        if (supplierConditions) {
            supplierConditions && setAssignedTrucksNumber(checkAssignedNumberOfTruck());
            supplierConditions &&
                setRemainingTrucks(
                    supplierConditions?.salesConditions?.numberOfTrucks -
                        checkAssignedNumberOfTruck()
                );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [supplierConditions, assignedTrucksNumber]);

    useEffect(() => {
        if (supplierConditions && supplierConditions?.supplierCreatorId && updateFilteredTrucks) {
            setSupplierConditions({
                ...supplierConditions,
                fullFillmentDetails: {
                    ...supplierConditions?.fullFillmentDetails,
                    suppliers: [
                        ...supplierConditions?.fullFillmentDetails.suppliers.map(
                            (supplier, index) => {
                                return {
                                    ...supplier,
                                    ...(supplier?.assignedTrucks.length > 0 && {
                                        selectedTrucks: Object.assign(
                                            {},
                                            supplier?.assignedTrucks.map(
                                                (truck) => truck?.truck?.value
                                            )
                                        ),
                                    }),
                                    ...(supplier?.assignedTrucks.length > 0 && {
                                        selectedDrivers: Object.assign(
                                            {},
                                            supplier?.assignedTrucks.map(
                                                (truck) => truck?.driver?.value
                                            )
                                        ),
                                    }),
                                    ...(supplier?.trucksList.length > 0 && {
                                        filteredTrucksList: filterArrayWithSelectedObject(
                                            supplier?.trucksList,
                                            Object.assign(
                                                {},
                                                supplier.assignedTrucks.map(
                                                    (truck) => truck?.truck?.value
                                                )
                                            )
                                        ),
                                    }),
                                    ...(supplier?.driversList?.length > 0 && {
                                        filteredDriversList: filterArrayWithSelectedObject(
                                            supplier?.driversList,
                                            Object.assign(
                                                {},
                                                supplier.assignedTrucks.map(
                                                    (truck) => truck?.driver?.value
                                                )
                                            )
                                        ),
                                    }),
                                };
                            }
                        ),
                    ],
                },
            });
            setUpdateFilteredTrucks(false);
        }
    }, [supplierConditions, updateFilteredTrucks]);

    useEffect(() => {
        if (supplierTrucksList?.data?.length > 0) {
            setSupplierConditions({
                ...supplierConditions,
                fullFillmentDetails: {
                    ...supplierConditions?.fullFillmentDetails,
                    suppliers: [
                        ...supplierConditions?.fullFillmentDetails.suppliers.map((supplier) => {
                            if (supplier?.supplier?.value === supplierTrucksList?.supplierId) {
                                return {
                                    ...supplier,
                                    trucksList: supplierTrucksList?.data,
                                    driversList: supplierDriversList?.data,
                                    ...(supplier?.assignedTruck?.length > 0 && {
                                        selectedTrucks: Object.assign(
                                            {},
                                            supplier?.assignedTrucks.map(
                                                (truck) => truck?.truck?.value
                                            )
                                        ),
                                    }),
                                    ...(supplier?.assignedTruck?.length > 0 && {
                                        selectedDrivers: Object.assign(
                                            {},
                                            supplier?.assignedTrucks.map(
                                                (truck) => truck?.driver?.value
                                            )
                                        ),
                                    }),
                                    ...(supplier.assignedTrucks.length > 0 && {
                                        filteredTrucksList: filterArrayWithSelectedObject(
                                            supplierTrucksList?.data,
                                            supplier?.selectedTrucks
                                        ),
                                    }),
                                    ...(supplier.assignedTrucks.length > 0 && {
                                        filteredDriversList: filterArrayWithSelectedObject(
                                            supplierDriversList?.data,
                                            supplier?.selectedDrivers
                                        ),
                                    }),
                                };
                            }

                            return supplier;
                        }),
                    ],
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [supplierTrucksList]);

    useEffect(() => {
        if (objection) {
            setSupplierConditions({ ...supplierConditions, objection });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [objection]);

    useEffect(() => {
        fetchSuppliersList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDrivers]);

    useEffect(() => {
        fetchSupplierTrucks();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTrucks]);

    const checkFormValidation = (e) => {
        e.preventDefault();
        checkWorkingConditionValidation();
        setClickOnSubmit(true);
    };

    const checkWorkingConditionValidation = () => {
        setClickOnSubmit(false);
        setFormIsValid(undefined);
        let validateWorkingCondition = true;
        if (
            !checkFullFillmentDetailsValidation() ||
            Number(supplierConditions?.pricingDetails.truckPricePerMonth) === 0 ||
            Number(supplierConditions?.pricingDetails.extraDayPrice) === 0 ||
            Number(supplierConditions?.pricingDetails.extraHourPrice) === 0 ||
            Number(supplierConditions?.pricingDetails.extraUnitDistancePrice) === 0 ||
            Number(supplierConditions?.pricingDetails.overnightPrice) === 0 ||
            (Number(supplierConditions?.fullFillmentDetails?.numberOfHelpers) > 0 &&
                Number(supplierConditions?.pricingDetails.pricePerHelper) === 0) ||
            (Number(supplierConditions?.fullFillmentDetails?.deliveryDelegate) > 0 &&
                Number(supplierConditions?.pricingDetails.pricePerDelegate) === 0) ||
            Number(supplierConditions?.pricingDetails.confirmSops) === false
        ) {
            validateWorkingCondition = false;
        } else validateWorkingCondition = true;

        setFormIsValid(validateWorkingCondition);
    };
    const checkFullFillmentDetailsValidation = () => {
        let isFullFillmentValid = true;
        // eslint-disable-next-line array-callback-return
        supplierConditions.fullFillmentDetails.suppliers.map((supplier) => {
            if (
                Number(supplier.numberOfTrucks) === 0 ||
                supplier.supplier.value === "" ||
                Number(supplier.supplier.kiloMeters === 0) ||
                Number(supplier.supplier.workingHoursPerDay === 0)
            ) {
                isFullFillmentValid = false;
            } else isFullFillmentValid = true;
        });
        return isFullFillmentValid;
    };

    const fetchTrucks = async (filterValue, supplierId) => {
        const data = await getTrucksList(filterValue, supplierId);
        setSupplierTrucksList({
            data: filterArrayWithSelectedObject(
                mapTruckOptionsToUi(_.values(data.entities["trucks"]), "id", "plateNumber"),
                selectedTrucks
            ),
            supplierId,
        });
        return filterArrayWithSelectedObject(
            mapTruckOptionsToUi(_.values(data.entities["trucks"]), "id", "plateNumber"),
            selectedTrucks
        );
    };

    const fetchDrivers = async (filterValue, supplierId) => {
        const data = await getDriversList(filterValue, supplierId);
        // setSupplierDriversList(mapTruckOptionsToUi(_.values(data.entities['drivers']), 'id', 'name'))
        // return mapTruckOptionsToUi(_.values(data.entities['drivers']), 'id', 'name')
        setSupplierDriversList({
            data: filterArrayWithSelectedObject(
                mapTruckOptionsToUi(_.values(data.entities["drivers"]), "id", "name"),
                selectedDrivers
            ),
            supplierId,
        });
        return filterArrayWithSelectedObject(
            mapTruckOptionsToUi(_.values(data.entities["drivers"]), "id", "name"),
            selectedDrivers
        );
    };

    const fetchSuppliersList = async (filterValue) => {
        const data = await getSuppliersList(filterValue);
        setFilteredSuppliersList(
            filterArrayWithSelectedObject(
                mapOptionsToUi(_.values(data?.entities["suppliers"]), "id", "name"),
                selectedSupplier
            )
        );

        return filterArrayWithSelectedObject(
            mapOptionsToUi(_.values(data?.entities["suppliers"]), "id", "name"),
            selectedSupplier
        );
    };

    const fetchSupplierProfileCondition = async (conditionId) => {
        const data = await getConditionById(conditionId);

        _.values(data?.entities["monthlyProjectTruckTypeConditions"])[0]["attributes"]
            ?.supplierCreatorId === null
            ? setShowEditableField(true)
            : setShowEditableField(false);

        const mappedData = mapSupplierConditionToUi(
            _.values(data?.entities["monthlyProjectTruckTypeConditions"]),
            _.values(data?.entities["suppliers"]),
            _.values(data?.entities["truckTypes"]),
            _.values(data?.entities["branches"]),
            _.values(data?.entities["objections"])
        );

        setSupplierConditions(mappedData);
        setInitialSupplierConditions(mappedData);

        const suppliers = mappedData.fullFillmentDetails?.suppliers;

        if (suppliers.length > 0) {
            setUpdatedSupplier(mapSuppliersTrucksToData(mappedData.fullFillmentDetails?.suppliers));
        }

        if (_.values(data?.entities["monthlyProjectTruckTypeConditions"]).length > 0) {
            setSelectedSupplier({
                ..._.values(data?.entities["monthlyProjectTruckTypeConditions"])[0][
                    "attributes"
                ].projectMonthlySuppliers.map((item) => item?.supplierId),
            });
            setUpdateFilteredTrucks(true);
        }

        if (_.values(data?.entities["objections"]).length > 0) {
            const objectLength = Object.keys(_.values(data?.entities["objections"])).length;
            getObjection(_.values(data?.entities["objections"])[objectLength - 1]?.id);
            setActiveObjection(_.values(data?.entities["objections"])[objectLength - 1]?.id);
        }
    };

    const fetchSupplierTrucks = () => {
        // eslint-disable-next-line array-callback-return
        supplierConditions.fullFillmentDetails.suppliers.map((supplier) => {
            fetchTrucks(null, supplier?.supplier?.value);
        });
    };

    const fetchSupplierDrivers = () => {
        supplierConditions.fullFillmentDetails.suppliers.map((supplier) => {
            fetchDrivers(null, supplier?.supplier?.value);
        });
    };

    const FetchProjectProfileCondition = (conditionId) => {
        // initialize state for new conditions
        setSupplierConditions({});
        setSupplierConditionsUpdatedData({});
        // setUpdatedSupplier([])
        if (conditionId !== "") {
            fetchSupplierProfileCondition(conditionId);
        }
    };
    const DeleteSupplier = async (conditionId, supplierId) => {
        deleteSupplierPerCondition(conditionId, supplierId)
            .then(async (res) => {
                dispatch(
                    setMessage({
                        content: `supplier Deleted successfully `,
                        isError: false,
                    })
                );
            })
            .catch((error) => {
                dispatch(
                    setMessage({
                        content: error,
                        title: `Couldn't delete supplier  `,
                        isError: true,
                    })
                );
            });
    };
    const handleEdit = () => {
        setIsEditable(true);
        // setUpdatedSupplier([])
        setSupplierConditionsUpdatedData({
            fullFillmentDetails: {
                suppliers: [],
            },
            pricingDetails: {},
        });
    };

    const handleEditProjectInfo = () => {
        trackAnalytics("Edit Project info clicks");
        setIsProjectInfoEditable(true);
    };

    const handleSubmitProjectInfo = () => {
        setIsLoading(true);
        updateAttachments();
    };

    const updateAttachments = async () => {
        if (supplierAttachments.length > 0) {
            await Promise.all(
                supplierAttachments.map(async (document) => {
                    try {
                        const file = await convertFileToBase64(document);
                        const data = {
                            data: {
                                type: "attachments",
                                attributes: {
                                    attachedItemId: projectId,
                                    attachedItemType: "Project",
                                    documentType: "supply_contract",
                                    document: file,
                                },
                            },
                        };
                        const response = await uploadProjectInfoAttachments(data);
                        const attachments = _.values(response?.entities["attachments"]);
                        const extractedAttachments = attachments.map((attachment) => {
                            const { documentType, document } = attachment?.attributes;
                            const url = document && document.url ? document.url : null;
                            return { documentType, url };
                        });

                        trackAnalytics(
                            `${getCurrentUserRoles}_project_info_save_edit`,
                            ...extractedAttachments
                        );
                    } catch (err) {
                        dispatch(
                            setMessage({
                                content: err,
                                title: `Couldn't update project profile attachments  `,
                                isError: true,
                            })
                        );
                    }
                })
            );
            updateProject();
        } else {
            updateProject();
        }
    };

    const updateProject = () => {
        const data = {
            projectFinancialLegal,
        };
        const changedProps = compareObjects(clientProject, { ...clientProject, ...data });
        const formData = mapUpdateSupplierProjectInfoToData(projectId, data);
        const mixPanelData = mapUpdateProjectInfoToMixPanel(
            changedProps,
            projectId,
            clientProject?.status
        );
        updateProjectInfo(projectId, formData)
            .then((res) => {
                setIsLoading(false);
                dispatch(
                    setMessage({
                        content: `project profile condition updated successfully `,
                        isError: false,
                    })
                );
                if (!clientProject?.projectFinancialLegal?.supplyPaymentCycleDays) {
                    // case of new project for supplier
                    trackAnalytics(`Submit new project info  - Supply`, mixPanelData);
                } else {
                    // case of edit project for supplier
                    trackAnalytics(`Save project info edits submissions`, mixPanelData);
                }
                history.push({
                    pathname: `/clientProjects/${projectId}`,
                    state: { clientId: organizationId, entityName: "projects" },
                });
                dispatch(showLoader());
                window.location.reload(false);
            })
            .catch((err) => {
                setIsLoading(false);
                dispatch(
                    setMessage({
                        content: err,
                        title: `Couldn't update project profile info  `,
                        isError: true,
                    })
                );
            });
    };

    const handleDeleteUploadedItem = (id) => {
        deleteSingleAttachment(id).then(() => {
            dispatch(
                setMessage({
                    content: `Attachment deleted successfully`,
                    isError: false,
                })
            );
            history.push({
                pathname: `/clientProjects/${projectId}`,
                state: { clientId: organizationId, entityName: "projects" },
            });
            dispatch(showLoader());
            // window.location.reload(false);
        });
    };

    const handleDeleteAllAttachements = () => {
        deleteAllAttachments().then((res) => {
            dispatch(
                setMessage({
                    content: `Attachments deleted successfully`,
                    isError: false,
                })
            );
            history.push({
                pathname: `/clientProjects/${projectId}`,
                state: { clientId: organizationId, entityName: "projects" },
            });
            dispatch(showLoader());
            // window.location.reload(false);
        });
    };

    const handleSupplierSubmitForm = () => {
        const FormData = mapSupplierFormToData(
            editableConditionId,
            supplierConditionsUpdatedData,
            supplierConditions?.fullFillmentDetails?.suppliers
        );
        const changedData = compareObjects(
            initialSupplierConditions,
            supplierConditionsUpdatedData
        );
        const workingConditionsMixPanelData = mapSupplierWorkingConditionsDataToMixPanel(
            changedData,
            updatedSupplier,
            projectId,
            clientProject?.status,
            supplierConditions?.status
        ); 
        FormData &&
            updateProfileSupplierForm(editableConditionId, FormData)
                .then((res) => {
                    setIsEditable(false);
                    // Check if it's a new project
                    if (!initialSupplierConditions?.pricingDetails?.truckPricePerMonth) {
                        trackAnalytics(
                            `Submit new project profile - Supply`,
                            workingConditionsMixPanelData
                        );
                    } else {
                        trackAnalytics(
                            `Save project info edits submissions`,
                            workingConditionsMixPanelData
                        );
                    }
                    setClickOnSubmit(false);
                    const id = _.values(res.entities["monthlyProjectSupplierConditions"])[0][
                        "attributes"
                    ].monthlyProjectId;
                    dispatch(
                        setMessage({
                            content: `project profile condition updated successfully `,
                            isError: false,
                        })
                    );
                    history.push({
                        pathname: `/clientProjects/${id}`,
                        state: { projectId: id, clientId: organizationId, entityName: "projects" },
                    });
                    window.location.reload();
                })
                .catch((error) => {
                    setClickOnSubmit(false);
                    setIsEditable(true);
                    setFormIsValid(false);

                    dispatch(
                        setMessage({
                            content: error,
                            title: `Couldn't update project profile conditions  `,
                            isError: true,
                        })
                    );
                });
    };

    const handleSupplierOnChangeSelect = (e, fieldName, index) => {
        setSupplierConditions({
            ...supplierConditions,
            fullFillmentDetails: {
                ...supplierConditions?.fullFillmentDetails,
                suppliers: [
                    ...supplierConditions?.fullFillmentDetails.suppliers.map(
                        (supplier, supplierIndex) => {
                            if (supplierIndex === index) {
                                if (fieldName === "supplier") {
                                    return {
                                        ...supplier,
                                        [fieldName]: e,
                                        trucksList: [],
                                        driversList: [],
                                        selectedTrucks: null,
                                        selectedDrivers: null,
                                        filteredTrucksList: [],
                                        filteredDriversList: [],
                                        assignedTrucks: {},
                                        numberOfTrucks: 0,
                                    };
                                }
                                return {
                                    ...supplier,
                                    [fieldName]: e,
                                };
                            }
                            return supplier;
                        }
                    ),
                ],
            },
        });
    };
    const handleSupplierOnChangeInput = (e, fieldName, index) => {
        setSupplierConditions({
            ...supplierConditions,
            fullFillmentDetails: {
                ...supplierConditions?.fullFillmentDetails,
                suppliers: [
                    ...supplierConditions?.fullFillmentDetails.suppliers.map(
                        (supplier, supplierIndex) => {
                            if (supplierIndex === index) {
                                if (fieldName === "numberOfTrucks") {
                                    return {
                                        ...supplier,
                                        [fieldName]: e?.target?.value,
                                        selectedTrucks: {},
                                        assignedTrucks: Array.from(
                                            { length: e?.target?.value },
                                            () => ({
                                                truck: {
                                                    value: "",
                                                    label: "",
                                                },
                                                driver: {
                                                    value: "",
                                                    label: "",
                                                },
                                            })
                                        ),
                                        filteredTrucksList: supplier?.trucksList,
                                        filteredDriversList: supplier?.driversList,
                                    };
                                }
                                return {
                                    ...supplier,
                                    [fieldName]: e?.target?.value,
                                };
                            }
                            return supplier;
                        }
                    ),
                ],
            },
        });
    };
    const handleOnChangeAssignedTrucks = (e, activeSupplierIndex, index) => {
        setSupplierConditions({
            ...supplierConditions,
            fullFillmentDetails: {
                ...supplierConditions?.fullFillmentDetails,
                suppliers: [
                    ...supplierConditions?.fullFillmentDetails?.suppliers.map(
                        (supplier, supplierIndex) => {
                            if (supplierIndex === activeSupplierIndex) {
                                return {
                                    ...supplier,
                                    assignedTrucks: [
                                        ...supplierConditions?.fullFillmentDetails?.suppliers[
                                            activeSupplierIndex
                                        ]?.assignedTrucks.map((truck, truckIndex) => {
                                            if (index === truckIndex) {
                                                return {
                                                    ...supplierConditions.fullFillmentDetails
                                                        .suppliers[activeSupplierIndex]
                                                        .assignedTrucks[index],
                                                    truck: {
                                                        ...(supplierConditions.fullFillmentDetails.suppliers[
                                                            activeSupplierIndex
                                                        ].assignedTrucks[index].truck = e),
                                                    },
                                                };
                                            }
                                            return truck;
                                        }),
                                    ],
                                    selectedTrucks: {
                                        ...supplier.selectedTrucks,
                                        [index]: e !== undefined ? Number(e?.value) : undefined,
                                    },
                                };
                            }
                            return supplier;
                        }
                    ),
                ],
            },
        });
    };

    const handleOnChangeAssignedDrivers = (e, activeSupplierIndex, index) => {
        setSupplierConditions({
            ...supplierConditions,
            fullFillmentDetails: {
                ...supplierConditions?.fullFillmentDetails,
                suppliers: [
                    ...supplierConditions?.fullFillmentDetails?.suppliers.map(
                        (supplier, supplierIndex) => {
                            if (supplierIndex === activeSupplierIndex) {
                                return {
                                    ...supplier,
                                    assignedTrucks: [
                                        ...supplierConditions?.fullFillmentDetails?.suppliers[
                                            activeSupplierIndex
                                        ]?.assignedTrucks.map((truck, truckIndex) => {
                                            if (index === truckIndex) {
                                                return {
                                                    ...supplierConditions.fullFillmentDetails
                                                        .suppliers[activeSupplierIndex]
                                                        .assignedTrucks[index],
                                                    driver: {
                                                        ...(supplierConditions.fullFillmentDetails.suppliers[
                                                            activeSupplierIndex
                                                        ].assignedTrucks[index].truck = e),
                                                    },
                                                };
                                            }
                                            return truck;
                                        }),
                                    ],
                                    selectedDrivers: {
                                        ...supplier.selectedDrivers,
                                        [index]: e !== undefined ? Number(e?.value) : undefined,
                                    },
                                };
                            }
                            return supplier;
                        }
                    ),
                ],
            },
        });
    };
    const AddSupplier = () => {
        setSupplierConditions({
            ...supplierConditions,
            fullFillmentDetails: {
                ...supplierConditions?.fullFillmentDetails,
                suppliers: [
                    ...supplierConditions?.fullFillmentDetails?.suppliers,
                    {
                        supplier: null,
                        numberOfTrucks: 0,
                        assignedTrucks: null,
                        kiloMeters: "",
                        workingHoursPerDay: "",
                    },
                ],
            },
        });
    };
    const checkAssignedNumberOfTruck = () =>
        supplierConditions?.fullFillmentDetails?.suppliers?.reduce(
            (prev, cur) => prev + Number(cur?.numberOfTrucks),
            0
        );
    const handleSupplierPricingOnChange = (e, fieldName) => {
        setSupplierConditions({
            ...supplierConditions,
            pricingDetails: {
                ...supplierConditions?.pricingDetails,
                [fieldName]: e,
            },
        });
        setSupplierConditionsUpdatedData({
            ...supplierConditionsUpdatedData,
            pricingDetails: {
                ...supplierConditionsUpdatedData?.pricingDetails,
                [fieldName]: e,
            },
        });
    };
    const deleteSupplier = (supplierIndex, conditionId, supplierId) => {
        setSupplierConditions({
            ...supplierConditions,
            fullFillmentDetails: {
                ...supplierConditions?.fullFillmentDetails,
                suppliers: [
                    ...supplierConditions.fullFillmentDetails.suppliers.filter(
                        (item, index) => index !== supplierIndex
                    ),
                ],
            },
        });
        setSupplierConditionsUpdatedData({
            ...supplierConditionsUpdatedData,
            fullFillmentDetails: {
                ...supplierConditionsUpdatedData?.fullFillmentDetails,
                suppliers: [
                    ...supplierConditionsUpdatedData.fullFillmentDetails.suppliers.filter(
                        (item, index) => index !== supplierIndex
                    ),
                ],
            },
        });
        supplierId !== "" && DeleteSupplier(conditionId, supplierId);
    };

    const updateSupplierField = (value, supplierIndex, supplierId, fieldName) => {
        setUpdatedSupplier({
            ...updatedSupplier,
            [supplierIndex]: {
                ...updatedSupplier[supplierIndex],
                supplierId,
                [fieldName]: value,
            },
        });
    };

    const updateAssignedTrucks = (
        value,
        truckIndex,
        supplierId,
        supplierIndex,
        NumberOfTrucks,
        workingHoursPerDay,
        kiloMeters
    ) => {
        setUpdatedSupplier({
            ...updatedSupplier,
            [supplierIndex]: {
                ...updatedSupplier[supplierIndex],
                supplierId,
                assignedTrucks: {
                    ...updatedSupplier[supplierIndex]?.assignedTrucks,
                    [truckIndex]: {
                        ...updatedSupplier[supplierIndex]?.assignedTrucks[truckIndex],
                        truck: value,
                    },
                },
                numberOfTrucks: NumberOfTrucks,
                ...(isEditable && {
                    workingHoursPerDay,
                    kiloMeters,
                }),
            },
        });
    };

    const updateAssignedDrivers = (
        value,
        truckIndex,
        supplierId,
        supplierIndex,
        NumberOfTrucks,
        workingHoursPerDay,
        kiloMeters
    ) => {
        setUpdatedSupplier({
            ...updatedSupplier,
            [supplierIndex]: {
                ...updatedSupplier[supplierIndex],
                supplierId,
                assignedTrucks: {
                    ...updatedSupplier[supplierIndex]?.assignedTrucks,
                    [truckIndex]: {
                        ...updatedSupplier[supplierIndex]?.assignedTrucks[truckIndex],
                        driver: value,
                    },
                },
                numberOfTrucks: NumberOfTrucks,
                ...(isEditable && {
                    workingHoursPerDay,
                    kiloMeters,
                }),
            },
        });
    };

    const updatedNumberOfTrucks = (value, supplierIndex, supplierId) => {
        setUpdatedSupplier({
            ...updatedSupplier,
            [supplierIndex]: {
                ...updatedSupplier[supplierIndex],
                supplierId,
                assignedTrucks: {},
                numberOfTrucks: value,
            },
        });
    };
    const updatedSupplierData = (value, supplierIndex) => {
        setUpdatedSupplier({
            ...updatedSupplier,
            [supplierIndex]: {
                ...updatedSupplier[supplierIndex],
                supplierId: value?.value,
                assignedTrucks: {},
                numberOfTrucks: 0,
            },
        });
    };
    const handleOnClick = (item) => {
        getObjection(item?.id);
        setActiveObjection(item?.id);
    };

    const getObjection = async (objectionId) => {
        const data = await getObjectionById(objectionId);

        setObjection(
            mapObjectionsToUi(
                _.values(data?.entities["creators"]),
                _.values(data?.entities["mentionedAdminUsers"]),
                _.values(data?.entities["adminUsers"]),
                _.values(data?.entities["items"]),
                _.values(data?.entities["sections"]),
                _.values(data?.entities["comments"]),
                _.values(data?.entities["objections"])
            )
        );
    };

    const objectionBody = () => (
        <ObjectionContainer>
            <TabList
                list={supplierConditions?.objectionsId}
                handleOnClick={handleOnClick}
            />
            <ObjectionsView
                objection={supplierConditions?.objection}
                activeObjectionId={activeObjection}
                projectId={projectId}
                submitObjectionSuccessfully={(value) => setSubmitObjectSuccess(value)}
            />
        </ObjectionContainer>
    );
    const SelectedSupplier = (value, index) => {
        setSelectedSupplier({ ...selectedSupplier, [index]: Number(value) });
    };

    return (
        <>
            <FormStyle onSubmit={checkFormValidation}>
                <ProjectInfo>
                    <PageTitle>
                        <FormattedMessage id="client.project-create-header" /> #{projectId}
                        <TagsContainer>
                            <Tags>{clientProject?.status}</Tags>
                        </TagsContainer>
                    </PageTitle>
                    {!isProjectInfoEditable && (
                        <StyledAction>
                            <Action
                                options={[
                                    {
                                        name: "edit",
                                        eventHandler: () => handleEditProjectInfo(),
                                        disable: false,
                                    },
                                ]}
                                icon="<MoreVertIcon/>"
                            />
                        </StyledAction>
                    )}
                    <FormRow>
                        <FormGroup>
                            <StyledLabel>Client Name</StyledLabel>
                            <DataView>{clientProject?.clientName}</DataView>
                        </FormGroup>
                        <FormGroup>
                            <StyledLabel>Project Name</StyledLabel>
                            <DataView>{clientProject?.name}</DataView>
                        </FormGroup>
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <StyledLabel>Project Type</StyledLabel>
                            <DataView>{clientProject?.projectType}</DataView>
                        </FormGroup>
                        <FormGroup>
                            <StyledLabel>Requested Date </StyledLabel>
                            <DataView>{clientProject?.requestedAt}</DataView>
                        </FormGroup>
                    </FormRow>
                    <ProjectFinancialLegalContainer>
                        <ProjectFinancialLegalForm
                            projectFinancialLegal={projectFinancialLegal}
                            isEditable={isProjectInfoEditable}
                            userRole="supplier"
                            setFinancialLegal={(fieldName, value) => {
                                setProjectFinancialLegal({
                                    ...projectFinancialLegal,
                                    [fieldName]: value,
                                });
                            }}
                            setSupplierAttachments={setSupplierAttachments}
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            onDeleteAllAttachements={handleDeleteAllAttachements}
                            setAllIllaDeductions={setAllIllaDeductions}
                            setAllClientDeductions={setAllClientDeductions}
                            allIllaDeductions={allIllaDeductions}
                            allClientDeductions={allClientDeductions}
                            deductionsValues={penaltiesAndDeductions}
                            setDeductionsValues={setPenaltiesAndDeductions}
                        />
                    </ProjectFinancialLegalContainer>
                    <div>
                        <QADetails
                            isEditable={isProjectInfoEditable}
                            attachements={clientProject?.qaDetails?.attachments}
                            // User can edit any of the following attributes
                            qADetails={qaDetails}
                            setQaDetails={(fieldName, value) => {
                                setQaDetails({
                                    ...qaDetails,
                                    [fieldName]: value,
                                });
                            }}
                            userRole="supplier"
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            onDeleteAllAttachements={handleDeleteAllAttachements}
                            standardsAndProceduresList={standardsAndProceduresList}
                        />
                        <SeparateLine />
                    </div>
                    {isProjectInfoEditable && (
                        <ButtonRow>
                            <Button
                                type="button"
                                name="Cancel"
                                btnStyle="secondBtn"
                                onChange={() => setShowDiscardModal(true)}
                            />
                            <Button
                                type="button"
                                name={isLoading ? <Spinner /> : "Save"}
                                btnStyle="primaryBtn"
                                onChange={handleSubmitProjectInfo}
                            />
                        </ButtonRow>
                    )}
                    <ModalComponent
                        header="Discard edits"
                        open={showDiscardEditModal}
                        onClose={() => {
                            setShowDiscardModal(false);
                        }}
                        submitBtnText="Discard"
                        onSubmit={() => {
                            trackAnalytics(`${getCurrentUserRoles}_project_cancel_editing`);
                            setShowDiscardModal(false);
                            setIsProjectInfoEditable(false);
                            setProjectFinancialLegal(clientProject?.projectFinancialLegal);
                        }}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        If you discard it now, you'll lose all the edits you've made
                    </ModalComponent>
                </ProjectInfo>
                <div>
                    <WorkingConditionSteps>
                        {clientProject?.salesConditionsId?.map((item, index) => (
                            <ConditionSteps
                                key={index}
                                className={index === activeWorkingCondition ? "active" : ""}
                                onClick={() => {
                                    setConditionId(item);
                                    setActiveWorkingCondition(index);
                                    setIsEditable(false);
                                    setSupplierWorkingConditionIsValid(true);
                                    FetchProjectProfileCondition(item);
                                    setEditableConditionId(item);
                                }}
                            >
                                Working condition {index + 1}
                            </ConditionSteps>
                        ))}
                    </WorkingConditionSteps>
                    <ProjectCondition>
                        {supplierConditions && (
                            <>
                                <div>
                                    <ActionsContainer>
                                        {supplierConditions?.status && (
                                            <Tags>{supplierConditions?.status}</Tags>
                                        )}
                                        <StyledAction>
                                            <Action
                                                options={[
                                                    {
                                                        name: "edit",
                                                        eventHandler: () => handleEdit(),
                                                        disable:
                                                            supplierConditions.supplierCreatorId ===
                                                            null,
                                                    },
                                                ]}
                                                icon="<MoreVertIcon/>"
                                            />
                                        </StyledAction>
                                    </ActionsContainer>
                                    <h3>Truck Details</h3>
                                    <FormRow>
                                        <FormGroup>
                                            <StyledLabel>Truck Type</StyledLabel>
                                            <DataView>
                                                {supplierConditions?.salesConditions?.truckTypeName}
                                            </DataView>
                                        </FormGroup>
                                        <FormGroup>
                                            <StyledLabel>Number of Trucks</StyledLabel>
                                            <DataView>
                                                {
                                                    supplierConditions?.salesConditions
                                                        ?.numberOfTrucks
                                                }
                                            </DataView>
                                        </FormGroup>
                                    </FormRow>
                                    {supplierConditions?.salesConditions?.hasPreferredModelYear && (
                                        <FormRow>
                                            <FormGroup>
                                                <StyledLabel>
                                                    Required model year starts from
                                                </StyledLabel>
                                                <DataView>
                                                    {
                                                        supplierConditions?.salesConditions
                                                            ?.requiredModelYearStartsFrom
                                                    }
                                                </DataView>
                                            </FormGroup>
                                        </FormRow>
                                    )}
                                </div>
                                <SeparateLine />
                                <ExtraOperationalRequirements
                                    isEditable={false}
                                    workingCondition={supplierConditions?.salesConditions}
                                />
                                <div>
                                    <h3>Client Operational Details</h3>
                                    <FormRow>
                                        <FormGroup>
                                            <StyledLabel>Kick-off Date</StyledLabel>
                                            <DataView>
                                                {supplierConditions?.salesConditions?.kickoffDate}
                                            </DataView>
                                        </FormGroup>
                                        <FormGroup>
                                            <StyledLabel>End Date</StyledLabel>
                                            <DataView>
                                                {supplierConditions?.salesConditions?.endDate}
                                            </DataView>
                                        </FormGroup>
                                    </FormRow>
                                    <FormRow>
                                        <FormGroup>
                                            <StyledLabel>Maximum number of drop-offs</StyledLabel>
                                            <DataView>
                                                {
                                                    supplierConditions?.salesConditions
                                                        ?.maximumNumberOfDropOff
                                                }
                                            </DataView>
                                        </FormGroup>
                                    </FormRow>
                                    <FormRow>
                                        <FormGroup>
                                            <StyledLabel>Operational Model</StyledLabel>
                                            <DataView>
                                                {supplierConditions?.salesConditions
                                                    ?.salesChannels &&
                                                    Array.from(
                                                        supplierConditions?.salesConditions
                                                            ?.salesChannels
                                                    )?.map((channel, index) => (
                                                        <span key={index}>{channel.value}</span>
                                                    ))}
                                            </DataView>
                                        </FormGroup>
                                        <FormGroup>
                                            <StyledLabel>Working Area</StyledLabel>
                                            <DataView>
                                                {supplierConditions?.salesConditions
                                                    ?.serviceAreas &&
                                                    Array.from(
                                                        supplierConditions?.salesConditions
                                                            ?.serviceAreas
                                                    ).map((area, index) => (
                                                        <span key={index}>{area.value}</span>
                                                    ))}
                                            </DataView>
                                        </FormGroup>
                                    </FormRow>
                                    <FormRow>
                                        <FormGroup>
                                            <StyledLabel>Pickup Location</StyledLabel>
                                            <DataView>
                                                {
                                                    supplierConditions?.salesConditions
                                                        ?.pickUpLocation
                                                }
                                            </DataView>
                                        </FormGroup>
                                        <FormGroup>
                                            <StyledLabel>Pickup Arrival Time</StyledLabel>
                                            <DataView>
                                                {moment(
                                                    supplierConditions?.salesConditions?.pickupTime
                                                ).format("LT")}
                                            </DataView>
                                        </FormGroup>
                                    </FormRow>
                                    <FormRow>
                                        <FormGroup>
                                            <StyledLabel>
                                                Number of Working Days per Month
                                            </StyledLabel>
                                            <DataView>
                                                {supplierConditions?.salesConditions?.workingDays}
                                            </DataView>
                                        </FormGroup>
                                        <FormGroup>
                                            <StyledLabel>Weekly Off Days</StyledLabel>
                                            <DataView>
                                                {supplierConditions?.salesConditions?.offDays &&
                                                    Array.from(
                                                        supplierConditions?.salesConditions?.offDays
                                                    )?.map((day, index) => (
                                                        <span key={index}>{day.value}</span>
                                                    ))}
                                            </DataView>
                                        </FormGroup>
                                    </FormRow>
                                    <FormRow>
                                        <FormGroup>
                                            <StyledLabel> Working Hours per Day</StyledLabel>
                                            <DataView>
                                                {
                                                    supplierConditions?.salesConditions
                                                        ?.workingHoursPerDay
                                                }
                                            </DataView>
                                        </FormGroup>
                                        <FormGroup>
                                            <StyledLabel>Mileage</StyledLabel>
                                            <DataView>
                                                {supplierConditions?.salesConditions?.kiloMeters}
                                            </DataView>
                                        </FormGroup>
                                    </FormRow>
                                    {supplierConditions?.salesConditions
                                        ?.operationalSpecialDetails && (
                                        <FormRow>
                                            <FormGroupTextEditor>
                                                <StyledLabel>
                                                    Special Requirements for Operational{" "}
                                                </StyledLabel>
                                                <DataView>
                                                    {
                                                        supplierConditions?.salesConditions
                                                            ?.operationalSpecialDetails
                                                    }
                                                </DataView>
                                            </FormGroupTextEditor>
                                        </FormRow>
                                    )}
                                    <SeparateLine />
                                </div>
                                <div>
                                    <h3>Facilitators</h3>
                                    <FormRow>
                                        <FormGroup>
                                            <StyledLabel>No. Of Helpers</StyledLabel>
                                            <DataView>
                                                {
                                                    supplierConditions?.salesConditions
                                                        ?.numberOfHelpers
                                                }
                                            </DataView>
                                        </FormGroup>
                                        <FormGroup>
                                            <StyledLabel>No. Of Delivery Delegates</StyledLabel>
                                            <DataView>
                                                {
                                                    supplierConditions?.salesConditions
                                                        ?.deliveryDelegate
                                                }
                                            </DataView>
                                        </FormGroup>
                                    </FormRow>
                                    {supplierConditions?.salesConditions
                                        ?.facilitatorsSpecialDetails !== "" && (
                                        <FormRow>
                                            <FormGroupTextEditor>
                                                <StyledLabel>
                                                    Special Requirements For Facilities
                                                </StyledLabel>
                                                <DataView>
                                                    {
                                                        supplierConditions?.salesConditions
                                                            ?.facilitatorsSpecialDetails
                                                    }
                                                </DataView>
                                            </FormGroupTextEditor>
                                        </FormRow>
                                    )}
                                </div>
                                <SeparateLine />

                                <div>
                                    <DefaultHintMsg>
                                        <TipsAndUpdatesIcon />
                                        Please Complete The Following Details
                                    </DefaultHintMsg>
                                    <h3>Supplier Fulfillment Details</h3>
                                    {supplierConditions &&
                                        supplierConditions?.fullFillmentDetails?.suppliers?.map(
                                            (item, supplierIndex) => (
                                                <>
                                                    <FormRow>
                                                        <FormGroup>
                                                            <SelectWithSearch
                                                                disableWithBorder={
                                                                    !isEditable ||
                                                                    !showEditableField
                                                                }
                                                                isEditable={
                                                                    isEditable || showEditableField
                                                                }
                                                                isMulti={false}
                                                                label="Supplier"
                                                                name="Supplier"
                                                                value={item?.supplier}
                                                                key={item?.supplier}
                                                                options={FilteredSuppliersList}
                                                                handleFilter={(value) =>
                                                                    fetchSuppliersList(value)
                                                                }
                                                                handleChange={(e) => {
                                                                    handleSupplierOnChangeSelect(
                                                                        e,
                                                                        "supplier",
                                                                        supplierIndex
                                                                    );
                                                                    updatedSupplierData(
                                                                        e,
                                                                        supplierIndex
                                                                    );
                                                                    fetchTrucks(null, e?.value);
                                                                    fetchDrivers(null, e?.value);
                                                                    SelectedSupplier(
                                                                        e?.value,
                                                                        supplierIndex
                                                                    );
                                                                }}
                                                                placeholder="Supplier"
                                                                required
                                                                error={
                                                                    !supplierWorkingConditionIsValid &&
                                                                    (isEditable ||
                                                                        showEditableField) &&
                                                                    (item?.supplier?.value ===
                                                                        null ||
                                                                        item?.supplier?.value ===
                                                                            undefined)
                                                                }
                                                            />
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <Input
                                                                disableWithBorder={
                                                                    !(
                                                                        (!isEditable ||
                                                                            !showEditableField) &&
                                                                        item?.supplier?.value !==
                                                                            "" &&
                                                                        item?.supplier !== null
                                                                    )
                                                                }
                                                                isEditable={
                                                                    (isEditable ||
                                                                        showEditableField) &&
                                                                    item?.supplier?.value !== "" &&
                                                                    item?.supplier !== null
                                                                }
                                                                label="Number Of Trucks"
                                                                name="numberOfTrucks"
                                                                type="number"
                                                                onChange={(e) => {
                                                                    handleSupplierOnChangeInput(
                                                                        e,
                                                                        "numberOfTrucks",
                                                                        supplierIndex
                                                                    );
                                                                    updatedNumberOfTrucks(
                                                                        e.target.value,
                                                                        supplierIndex,
                                                                        item?.supplier?.value
                                                                    );
                                                                }}
                                                                required
                                                                placeholder={
                                                                    isEditable || showEditableField
                                                                        ? "0"
                                                                        : ""
                                                                }
                                                                value={item?.numberOfTrucks}
                                                                min="1"
                                                                error={
                                                                    !supplierWorkingConditionIsValid &&
                                                                    isEditable &&
                                                                    showEditableField &&
                                                                    item?.numberOfTrucks === 0
                                                                }
                                                            />
                                                        </FormGroup>
                                                        {(isEditable || showEditableField) && (
                                                            <TrashIconStyle>
                                                                <TrashIcon
                                                                    onClick={() =>
                                                                        deleteSupplier(
                                                                            supplierIndex,
                                                                            editableConditionId,
                                                                            item?.supplier?.value
                                                                        )
                                                                    }
                                                                />
                                                            </TrashIconStyle>
                                                        )}
                                                    </FormRow>
                                                    {item?.numberOfTrucks > 0 &&
                                                        item?.assignedTrucks.length > 0 &&
                                                        item?.assignedTrucks?.map(
                                                            (truck, index) => (
                                                                <FormRow>
                                                                    <FormGroup>
                                                                        <SelectWithSearch
                                                                            isEditable={
                                                                                isEditable ||
                                                                                showEditableField
                                                                            }
                                                                            isMulti={false}
                                                                            label={`Truck ${
                                                                                index + 1
                                                                            }`}
                                                                            value={truck.truck}
                                                                            key={truck.truck}
                                                                            name="truckType"
                                                                            options={
                                                                                item?.filteredTrucksList
                                                                            }
                                                                            handleFilter={(value) =>
                                                                                fetchTrucks(
                                                                                    value,
                                                                                    item?.supplier
                                                                                        ?.value
                                                                                )
                                                                            }
                                                                            handleChange={(e) => {
                                                                                handleOnChangeAssignedTrucks(
                                                                                    e,
                                                                                    supplierIndex,
                                                                                    index
                                                                                );
                                                                                updateAssignedTrucks(
                                                                                    e?.value,
                                                                                    index,
                                                                                    item?.supplier
                                                                                        ?.value,
                                                                                    supplierIndex,
                                                                                    item?.numberOfTrucks,
                                                                                    item?.workingHoursPerDay,
                                                                                    item?.kiloMeters
                                                                                );
                                                                                setSelectedTrucks({
                                                                                    ...selectedTrucks,
                                                                                    [supplierIndex]:
                                                                                        {
                                                                                            ...selectedTrucks[
                                                                                                supplierIndex
                                                                                            ],
                                                                                            [index]:
                                                                                                Number(
                                                                                                    e?.value
                                                                                                ),
                                                                                        },
                                                                                });
                                                                            }}
                                                                        />
                                                                    </FormGroup>
                                                                    <FormGroup>
                                                                        <SelectWithSearch
                                                                            isEditable={
                                                                                isEditable ||
                                                                                showEditableField
                                                                            }
                                                                            isMulti={false}
                                                                            label={`Driver ${
                                                                                index + 1
                                                                            }`}
                                                                            value={truck.driver}
                                                                            key={truck.driver}
                                                                            name="driver"
                                                                            options={
                                                                                item?.filteredDriversList
                                                                            }
                                                                            handleFilter={(value) =>
                                                                                fetchDrivers(
                                                                                    value,
                                                                                    item?.supplier
                                                                                        ?.value
                                                                                )
                                                                            }
                                                                            handleChange={(e) => {
                                                                                handleOnChangeAssignedDrivers(
                                                                                    e,
                                                                                    supplierIndex,
                                                                                    index
                                                                                );
                                                                                updateAssignedDrivers(
                                                                                    e?.value,
                                                                                    index,
                                                                                    item?.supplier
                                                                                        ?.value,
                                                                                    supplierIndex,
                                                                                    item?.numberOfTrucks,
                                                                                    item?.workingHoursPerDay,
                                                                                    item?.kiloMeters
                                                                                );
                                                                                setSelectedDrivers({
                                                                                    ...selectedDrivers,
                                                                                    [supplierIndex]:
                                                                                        {
                                                                                            ...selectedDrivers[
                                                                                                supplierIndex
                                                                                            ],
                                                                                            [index]:
                                                                                                Number(
                                                                                                    e?.value
                                                                                                ),
                                                                                        },
                                                                                });
                                                                            }}
                                                                        />
                                                                    </FormGroup>
                                                                </FormRow>
                                                            )
                                                        )}
                                                    <FormRow>
                                                        <FormGroup>
                                                            <Input
                                                                disableWithBorder={
                                                                    !(
                                                                        (!isEditable ||
                                                                            !showEditableField) &&
                                                                        item?.supplier?.value !==
                                                                            "" &&
                                                                        item?.supplier !== null
                                                                    )
                                                                }
                                                                isEditable={
                                                                    (isEditable ||
                                                                        showEditableField) &&
                                                                    item?.supplier?.value !== "" &&
                                                                    item?.supplier !== null
                                                                }
                                                                label="Working Hours per Day"
                                                                name="workingHoursPerDay"
                                                                type="number"
                                                                onChange={(e) => {
                                                                    handleSupplierOnChangeInput(
                                                                        e,
                                                                        "workingHoursPerDay",
                                                                        supplierIndex
                                                                    );
                                                                    updateSupplierField(
                                                                        e.target.value,
                                                                        supplierIndex,
                                                                        item?.supplier?.value,
                                                                        "workingHoursPerDay"
                                                                    );
                                                                }}
                                                                required
                                                                placeholder="1"
                                                                value={item?.workingHoursPerDay}
                                                                max="24"
                                                                min="1"
                                                                error={
                                                                    !supplierWorkingConditionIsValid &&
                                                                    isEditable &&
                                                                    item?.workingHoursPerDay === 0
                                                                }
                                                            />
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <MileageInput>
                                                                <Input
                                                                    disableWithBorder={
                                                                        !(
                                                                            (!isEditable ||
                                                                                !showEditableField) &&
                                                                            item?.supplier
                                                                                ?.value !== "" &&
                                                                            item?.supplier !== null
                                                                        )
                                                                    }
                                                                    isEditable={
                                                                        (isEditable ||
                                                                            showEditableField) &&
                                                                        item?.supplier?.value !==
                                                                            "" &&
                                                                        item?.supplier !== null
                                                                    }
                                                                    label="Mileage"
                                                                    name="Mileage"
                                                                    type="number"
                                                                    onChange={(e) => {
                                                                        handleSupplierOnChangeInput(
                                                                            e,
                                                                            "kiloMeters",
                                                                            supplierIndex
                                                                        );
                                                                        updateSupplierField(
                                                                            e.target.value,
                                                                            supplierIndex,
                                                                            item?.supplier?.value,
                                                                            "kiloMeters"
                                                                        );
                                                                    }}
                                                                    required
                                                                    placeholder="1"
                                                                    value={item?.kiloMeters}
                                                                    min="1"
                                                                    error={
                                                                        !supplierWorkingConditionIsValid &&
                                                                        isEditable &&
                                                                        item?.kiloMeters === 0
                                                                    }
                                                                />
                                                                <MileageUnit>KM</MileageUnit>
                                                            </MileageInput>
                                                        </FormGroup>
                                                    </FormRow>
                                                    <SeparateLine />
                                                </>
                                            )
                                        )}
                                    {(isEditable || showEditableField) && (
                                        <FormRow>
                                            <StylesButtonLink onClick={AddSupplier}>
                                                <PlusIcon />
                                                Add Supplier
                                            </StylesButtonLink>
                                        </FormRow>
                                    )}
                                    <FormRow>
                                        <FormGroup>
                                            <Input
                                                disableWithBorder={false}
                                                isEditable={isEditable || showEditableField}
                                                label="No. of Helpers"
                                                name="numberOfHelpers"
                                                type="number"
                                                onChange={(e) => {
                                                    setSupplierConditions({
                                                        ...supplierConditions,
                                                        fullFillmentDetails: {
                                                            ...supplierConditions?.fullFillmentDetails,
                                                            numberOfHelpers:
                                                                e.target.value >
                                                                supplierConditions?.salesConditions
                                                                    ?.numberOfHelpers
                                                                    ? supplierConditions
                                                                          ?.salesConditions
                                                                          ?.numberOfHelpers
                                                                    : e.target.value,
                                                        },
                                                    });
                                                    setSupplierConditionsUpdatedData({
                                                        ...supplierConditionsUpdatedData,
                                                        fullFillmentDetails: {
                                                            ...supplierConditionsUpdatedData?.fullFillmentDetails,
                                                            numberOfHelpers:
                                                                e.target.value >
                                                                supplierConditions?.salesConditions
                                                                    ?.numberOfHelpers
                                                                    ? supplierConditions
                                                                          ?.salesConditions
                                                                          ?.numberOfHelpers
                                                                    : e.target.value,
                                                        },
                                                    });
                                                }}
                                                required={false}
                                                placeholder={
                                                    isEditable || showEditableField ? "0" : ""
                                                }
                                                value={
                                                    supplierConditions?.fullFillmentDetails
                                                        ?.numberOfHelpers
                                                }
                                                key={
                                                    supplierConditions?.fullFillmentDetails
                                                        ?.numberOfHelpers
                                                }
                                                max={
                                                    supplierConditions?.salesConditions
                                                        ?.numberOfHelpers
                                                }
                                                min="0"
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Input
                                                disableWithBorder={false}
                                                isEditable={isEditable || showEditableField}
                                                label="No. of Delivery Delegates"
                                                name="numberOfDelegates"
                                                type="number"
                                                onChange={(e) => {
                                                    setSupplierConditions({
                                                        ...supplierConditions,
                                                        fullFillmentDetails: {
                                                            ...supplierConditions?.fullFillmentDetails,
                                                            deliveryDelegate:
                                                                e.target.value >
                                                                supplierConditions?.salesConditions
                                                                    ?.deliveryDelegate
                                                                    ? supplierConditions
                                                                          ?.salesConditions
                                                                          ?.deliveryDelegate
                                                                    : e.target.value,
                                                        },
                                                    });
                                                    setSupplierConditionsUpdatedData({
                                                        ...supplierConditionsUpdatedData,
                                                        fullFillmentDetails: {
                                                            ...supplierConditionsUpdatedData?.fullFillmentDetails,
                                                            deliveryDelegate:
                                                                e.target.value >
                                                                supplierConditions?.salesConditions
                                                                    ?.deliveryDelegate
                                                                    ? supplierConditions
                                                                          ?.salesConditions
                                                                          ?.deliveryDelegate
                                                                    : e.target.value,
                                                        },
                                                    });
                                                }}
                                                required={false}
                                                placeholder={
                                                    isEditable || showEditableField ? "0" : ""
                                                }
                                                value={
                                                    supplierConditions?.fullFillmentDetails
                                                        ?.deliveryDelegate
                                                }
                                                max={
                                                    supplierConditions?.salesConditions
                                                        ?.deliveryDelegate
                                                }
                                                min="0"
                                            />
                                        </FormGroup>
                                    </FormRow>
                                    <FormRow>
                                        <>
                                            {Number(assignedTrucksNumber) <
                                                Number(
                                                    supplierConditions?.salesConditions
                                                        ?.numberOfTrucks
                                                ) && (
                                                <HintMsg>
                                                    <WarningAmberIcon />
                                                    Partial Fulfillment - You have provided{" "}
                                                    {assignedTrucksNumber} trucks out of{" "}
                                                    {
                                                        supplierConditions?.salesConditions
                                                            ?.numberOfTrucks
                                                    }
                                                </HintMsg>
                                            )}

                                            {Number(assignedTrucksNumber) ===
                                                Number(
                                                    supplierConditions?.salesConditions
                                                        ?.numberOfTrucks
                                                ) && (
                                                <HintSuccessMsg>
                                                    <DoneOutlineIcon />
                                                    fully Fulfillment - You have provided{" "}
                                                    {assignedTrucksNumber} trucks out of{" "}
                                                    {
                                                        supplierConditions?.salesConditions
                                                            ?.numberOfTrucks
                                                    }
                                                </HintSuccessMsg>
                                            )}
                                        </>
                                    </FormRow>
                                </div>
                                <SeparateLine />

                                <ClientPricingDetails
                                    isEditable={false}
                                    salesConditions={supplierConditions}
                                />

                                <SupplierPricingDetails
                                    supplierConditions={supplierConditions}
                                    isEditable={isEditable}
                                    showEditableField={showEditableField}
                                    handleSupplierPricingOnChange={handleSupplierPricingOnChange}
                                    supplierWorkingConditionIsValid={
                                        supplierWorkingConditionIsValid
                                    }
                                />

                                {(isEditable || showEditableField) && (
                                    <FormRow>
                                        <ConfirmSpo>
                                            <CheckBox
                                                label="Please Confirm that you had communicated the project operational details & ILLA’s SOPs  with the suppliers ?"
                                                name="confirmSops"
                                                type="checkbox"
                                                onChange={(e) =>
                                                    handleSupplierPricingOnChange(
                                                        e.target.checked,
                                                        "confirmSops"
                                                    )
                                                }
                                                required
                                                error={
                                                    !supplierWorkingConditionIsValid &&
                                                    (isEditable || showEditableField) &&
                                                    supplierConditions?.pricingDetails
                                                        ?.confirmSops === false
                                                }
                                                value={
                                                    supplierConditions?.pricingDetails?.confirmSops
                                                }
                                            />
                                        </ConfirmSpo>
                                    </FormRow>
                                )}
                            </>
                        )}

                        {!supplierWorkingConditionIsValid && (isEditable || showEditableField) && (
                            <FormRow>
                                <ErrorHint>
                                    <Error>Please Fill the Required Field</Error>
                                </ErrorHint>
                            </FormRow>
                        )}
                        {(isEditable || showEditableField) && (
                            <ButtonRow>
                                <Button
                                    type="submit"
                                    name={isEditable ? "Edit" : "Submit"}
                                    btnStyle="primaryBtn"
                                />
                            </ButtonRow>
                        )}
                    </ProjectCondition>
                </div>
            </FormStyle>
            {supplierConditions &&
                supplierConditions?.objectionsId?.length > 0 &&
                supplierConditions?.objection && (
                    <div>
                        <AccordionComponent
                            id="Objection"
                            title="objections"
                            body={objectionBody()}
                            defaultExpanded
                        />
                    </div>
                )}
        </>
    );
}
